'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reduxForm = require('redux-form');

var _translate = require('../../language/translate');

var _RadioGroupComponent = require('../input/RadioGroupComponent');

var _RadioGroupComponent2 = _interopRequireDefault(_RadioGroupComponent);

var _LabelledInputComponent = require('../input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _ExpandableHintComponent = require('../input/ExpandableHintComponent');

var _ExpandableHintComponent2 = _interopRequireDefault(_ExpandableHintComponent);

var _TugoGroupedCheckbox = require('./TugoGroupedCheckbox');

var _TugoGroupedCheckbox2 = _interopRequireDefault(_TugoGroupedCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MedicalQuestionnaire = function (_Component) {
  _inherits(MedicalQuestionnaire, _Component);

  function MedicalQuestionnaire(props) {
    _classCallCheck(this, MedicalQuestionnaire);

    var _this = _possibleConstructorReturn(this, (MedicalQuestionnaire.__proto__ || Object.getPrototypeOf(MedicalQuestionnaire)).call(this, props));

    _this.state = {
      // show: false,
    };
    return _this;
  }

  _createClass(MedicalQuestionnaire, [{
    key: 'getNestedField',
    value: function getNestedField(obj, path) {
      return path.split('.').reduce(function (acc, part) {
        return acc && acc[part];
      }, obj);
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      this.props.onClose();
      this.props.onChangeHook();
    }
  }, {
    key: 'renderRadioQuestions',
    value: function renderRadioQuestions(radioQuestions, applicantsWithMQ) {
      return radioQuestions.map(function (question, qIdx) {
        var questionHint = question.hint ? (0, _translate.t)(question.hint) : '';

        var fieldsByApplicant = applicantsWithMQ.map(function (applicant) {
          var field = applicant.additional_data.mq[question.key];

          return field;
        });

        return _react2.default.createElement(
          _reactBootstrap.Row,
          { key: 'question_' + qIdx, style: { marginBottom: '20px' } },
          _react2.default.createElement(
            _reactBootstrap.Col,
            { sm: 12 },
            _react2.default.createElement(_LabelledInputComponent2.default, {
              hasExpandableHint: !!question.hint,
              expandableHintId: 'mqHint' + question.key,
              expandableHintTitle: question.hintTitle,
              expandableHintContent: questionHint,
              expandableHintIsRawHtml: true,
              inputId: 'mq_' + question.key,
              inputLabel: question.text,
              inputComponent: question.options ? _RadioGroupComponent2.default : function () {
                return null;
              },
              inputComponentField: fieldsByApplicant,
              inputComponentProps: {
                options: question.options || []
              },
              tugoMq: true,
              applicants: applicantsWithMQ
            })
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          applicantsWithMQ = _props.applicantsWithMQ,
          show = _props.show,
          onClose = _props.onClose;

      var radioQuestions = [{
        key: 'mq1',
        text: '1. Have you had any of the following? Choose the one most recent event.',
        hint: 'Carefully review the conditions listed in Question 3 under the Cardiovascular section too, and select any conditions that you\'ve been diagnosed with.',
        hintTitle: '',
        options: null
      }, {
        key: 'QT-TUP-1A',
        text: 'Myocardial infarction also known as heart attack, stroke or Transient Ischemic Attack (TIA) also known as mini-stroke',
        options: [{ value: 'q1a1', text: 'Less than 1 year ago' }, { value: 'q1a2', text: '1 to 5 years ago' }, { value: 'q1a3', text: 'More than 5 years ago' }, { value: 'q1a4', text: 'None' }]
      }, {
        key: 'QT-TUP-1B',
        text: 'Arterial by-pass, angioplasty and/or the placement of a stent for a cardiovascular condition',
        options: [{ value: 'q2a1', text: 'Less than 1 year ago' }, { value: 'q2a2', text: '1 to 5 years ago' }, { value: 'q2a3', text: 'More than 5 years ago' }, { value: 'q2a4', text: 'None' }]
      }, {
        key: 'QT-TUP-2',
        text: '2. Do you currently have hypertension also known as high blood pressure?',
        hint: 'If you\'ve been diagnosed with hypertension also known as high blood pressure, but aren\'t prescribed any medication, choose Yes with no alteration to medication in the last 6 months.',
        hintTitle: '',
        options: [{ value: 'q3a1', text: 'No' }, { value: 'q3a2', text: 'Yes with no alteration to medication in the last 6 months' }, { value: 'q3a3', text: 'Yes with an alteration to medication in the last 6 months' }]
      }, {
        key: 'QT-TUP-5',
        text: '5. In the last 12 months, have you smoked any tobacco products, or vaped any nicotine products (including e-cigarettes)?',
        options: [{ value: 'q9a1', text: 'Yes' }, { value: 'q9a2', text: 'No' }]
      }];

      return _react2.default.createElement(
        _reactBootstrap.Modal,
        { show: show, onHide: onClose, bsSize: 'lg' },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          { closeButton: true },
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            (0, _translate.t)('Medical Questionnaire')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              { className: 'tugo-disclaimer' },
              _react2.default.createElement(
                'b',
                null,
                (0, _translate.t)('All applicants 60 years of age and older must answer the following questions as of today\'s date to determine the rate.')
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              (0, _translate.t)('It’s important to answer the Medical Questionnaire correctly. If you qualify for the insurance but you or a representative buying insurance on your behalf inaccurately answer any of the Rate Qualification Questions, a $15,000 USD deductible applies to any incident claimed, in addition to any other deductible you may have selected. At the time of a claim, if the answers are not complete or accurate, coverage won’t be provided until you correct your answers, and if applicable, you pay any additional premium that may be required.')
            ),
            _react2.default.createElement(
              'a',
              { href: 'https://new-sell.tugo.com/content/mhqQA', target: '_blank', rel: 'noopener noreferrer' },
              _react2.default.createElement(_reactBootstrap.Glyphicon, {
                glyph: 'info-sign',
                className: 'ingle-form-expandable-hint info-icon padding-right',
                'aria-hidden': 'true'
              }),
              (0, _translate.t)('What You Need to Know about the Medical Questionnaire (MQ)')
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'a',
              { href: 'https://new-sell.tugo.com/content/medicalDefinitions', target: '_blank', rel: 'noopener noreferrer' },
              _react2.default.createElement(_reactBootstrap.Glyphicon, {
                glyph: 'book',
                className: 'ingle-form-expandable-hint info-icon padding-right',
                'aria-hidden': 'true'
              }),
              (0, _translate.t)('Medical Terminology')
            ),
            _react2.default.createElement(
              'h3',
              null,
              (0, _translate.t)('Rate Qualification Questions')
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Grid,
            { fluid: true },
            this.renderRadioQuestions(radioQuestions.slice(0, 4), applicantsWithMQ),
            _react2.default.createElement(_TugoGroupedCheckbox2.default, {
              applicants: applicantsWithMQ,
              updateProp: this.props.updateProp,
              values: this.props.formValues
            }),
            this.renderRadioQuestions(radioQuestions.slice(4, 5), applicantsWithMQ)
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          _react2.default.createElement(
            _reactBootstrap.Button,
            { className: 'btn btn-primary button margin-left', onClick: this.handleSave.bind(this) },
            (0, _translate.t)('Save & Close')
          )
        )
      );
    }
  }]);

  return MedicalQuestionnaire;
}(_react.Component);

MedicalQuestionnaire.propTypes = {
  applicantsWithMQ: _react.PropTypes.array.isRequired,
  onClose: _react.PropTypes.func.isRequired,
  show: _react.PropTypes.bool,
  updateProp: _react.PropTypes.func,
  formValues: _react.PropTypes.object,
  onChangeHook: _react.PropTypes.func

};
exports.default = MedicalQuestionnaire;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/TugoMedicalQuestionnaire.jsx
// module id = 1671
// module chunks = 0